
import Divider from 'vux/src/components/divider/index.vue'
import Sticky from 'vux/src/components/sticky/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'


export default {
components: {
XHeader,
Tab,
TabItem,
Sticky,
Divider,
XButton,
Swiper,
SwiperItem
},
name: 'invitation',
data() {
return {

list: [],
select: '',
index: 0,
auditlist: [],
needAuditlist: []
}
},
created() {
var opid = localStorage.getItem('userid')
var head = {
headers: {
token: localStorage.getItem('token'),
opid: opid
}
}
var app = this
this.$http.get('/api/v1/accounts/' + opid + '/recommend', head)
.then(function (response) {
for (var i = 0; i < response.data.length; i++) {
if (response.data[i].need_audit === false) {
app.auditlist.push(response.data[i])
} else {
app.needAuditlist.push(response.data[i])
}
}
app.list.push('审核通过（' + app.auditlist.length + ')')
app.list.push('待审核（' + app.needAuditlist.length + ')')
app.select = app.list[0]
})
.catch(function (error) {
if (error.response) {
if (error.response.data.error_message) {
app.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string
})
} else {
app.$vux.alert.show({
title: '',
content: '服务器错误，请稍后重试'
})
}
} else {
app.$vux.alert.show({
title: '',
content: '服务器错误，请稍后重试'
})
console.log('Error', error.message)
}
})
}
}



// WEBPACK FOOTER //
// ./src/components/invitation.vue